import React, { useState } from "react";
import { reduxForm, InjectedFormProps } from "redux-form";
import { BankAccountChildProps } from "../../types/props";
import { FORM_NAMES } from "../../constants/forms";
import useBeneDetailsInit from "../../hooks/bankAccounts/useBeneDetailsInit";
import { UpdateBankAccountFormFields } from "../../actions/bankAccounts";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import { RootState } from "../../types/redux";
import { ErrorObj } from "../../types/errors";
import { generateUniqueInteger } from "../../services/formatter";
import useBeneficiaryCountryEffects from "../../hooks/bankAccounts/useBeneficiaryCountryEffects";
import useBankDetailsInit from "../../hooks/bankAccounts/useBankDetailsInit";

import InputSkeletonGroup from "../../components/Common/Loaders/InputSkeleton";
import ActionLink from "../../components/Common/ActionLink";
import DynamicForm from "../../components/MoneyTransfer/DynamicForm";
import CancelModal from "../../components/BankAccounts/CancelModal";

const BankAccountFormWrapper: React.FC<BankAccountChildProps & InjectedFormProps<{}, BankAccountChildProps>> = (props: BankAccountChildProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { setTitle, setSubTitle, setForwardButton } = props;
  const { destinationCurrencyName, pages, instructionHeader, instructionBody, nonFieldValidationErrors, type } = useSelector((state: RootState) => state.bankAccounts);

  const isBeneficiaryPage = window.location.pathname.includes(ROUTES.BANKS_ACCOUNTS.BENEFICIARY_DETAILS);
  const isBankPage = window.location.pathname.includes(ROUTES.BANKS_ACCOUNTS.BANK_DETAILS);

  useBeneDetailsInit({ setTitle, setSubTitle, setForwardButton, setLoading, type, pages, enabled: isBeneficiaryPage });
  useBeneficiaryCountryEffects({ pages, enabled: isBeneficiaryPage });
  useBankDetailsInit({ setTitle, setSubTitle, setForwardButton, setLoading, type, enabled: isBankPage });

  /**
   * Handle reset to country selection page
   */
  const handleResetToCountrySelection = () => {
    dispatch(UpdateBankAccountFormFields(null));
    history.push(ROUTES.BANKS_ACCOUNTS.COUNTRY);
  }

  return (
    <>
      {loading &&
        <InputSkeletonGroup numInputs={6} />
      }

      {!loading && pages?.length > 0 &&
        <>
          <p className="spacing-bottom-small spacing-top-small">{i18n.t("COMMON.CURRENCY")}: <span className="bold">{destinationCurrencyName}</span></p>
          <p>
            {i18n.t("PAGES.BANK_ACCOUNTS.BENEFICIARY_BANK_DETAILS.P1")} {" "}
            <ActionLink
              text="click here"
              clickFunc={handleResetToCountrySelection}
            />
          </p>
          {instructionHeader && <div className="spacing-bottom-small" dangerouslySetInnerHTML={{ __html: instructionHeader }} />}
          {instructionBody && <div className="spacing-bottom-small" dangerouslySetInnerHTML={{ __html: instructionBody }} />}

          {nonFieldValidationErrors?.length > 0 &&
            nonFieldValidationErrors.map((error: ErrorObj) => (
              <p className="error" key={generateUniqueInteger()}>{error.errorMessage}</p>
            ))
          }
          <form className="spacing-top-small">
            <DynamicForm fieldCategory={isBeneficiaryPage ? pages[0] : pages[1]} formName={FORM_NAMES.BANK_ACCOUNTS} />
          </form>

          <CancelModal />
        </>
      }
    </>
  );
}

export default reduxForm<{}, BankAccountChildProps>({
  form: FORM_NAMES.BANK_ACCOUNTS,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(BankAccountFormWrapper);